import React from 'react';

const RelatoriosConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/relatorios',
      component: React.lazy(() => import('./Relatorios')),
    },
  ],
};

export default RelatoriosConfig;
